<app-modal [title]="title">
    <ng-content></ng-content>
  </app-modal>
